import { generate_guid } from "@/rlMxModules/utils/util";

class rlSlabHoleModelSectData {
  constructor(Kine = null, ShapeVal = null, Guid = null) {
    this.Kind;
    this.ShapeVal = ShapeVal; //截面尺寸
    this.Guid = Guid ? Guid : generate_guid();
  }
}

export default rlSlabHoleModelSectData;
